import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import UnauthorizedPage from "../pages/UnauthorizedPage";
import { usePermissions } from "../hooks/usePermissions";

export interface ProtectedRouteProps {
  requiredPermissions?: string[];
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredPermissions = [],
  children,
}) => {
  const location = useLocation();
  const { userInfo, hasAllPermissions } = usePermissions();

  if (!userInfo) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (requiredPermissions.length > 0) {
    if (!hasAllPermissions(requiredPermissions)) {
      return <UnauthorizedPage />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
